<template>
  <a-modal
      v-if="record"
      :destroyOnClose="true"
      v-model="visible"
      :width="1400"
      :footer="null"
  >
    <a-steps :current="current" style="width: 70%;margin: 0 auto">
      <a-step v-for="item in steps" :key="item.title" :title="item.title"/>
    </a-steps>
    <div style="margin-top: 30px" v-show="current===0">
      <h3>
        <b>候选人信息：</b>
      </h3>
      <div class="card">
        <a-row
            class="row"
            type="flex"
            justify="space-between"
            :gutter="20"
            style="padding:10px 0 0 25px"
        >
          <a-col span="12">
            <p>
              <span style="font-weight: bold">{{ record.resume.name }}</span>
              <span style="color: #FC5E4F;margin-left: 10px">(匹配度：{{ record.resume.resume_match_degree }})</span>
            </p>
          </a-col>
        </a-row>
        <a-row
            class="row"
            type="flex"
            justify="space-between"
            :gutter="20"
            style="padding:0 0 0 25px"
        >
          <a-col span="12">
            {{ record.resume.gender_id == 1 ? '男' : record.resume.gender_id == 2 ? '女' : '不详' }}
            <a-divider type="vertical"/>
            {{ record.resume.city_name }}
            <a-divider type="vertical"/>
            {{ record.resume.education_name }}
            <a-divider type="vertical"/>
            {{ record.resume.working_years_name }}
          </a-col>
        </a-row>
        <a-divider/>
        <div class="time">
          <a-icon type="clock-circle"/>
          更新时间：{{ record.updated_at }}
        </div>
      </div>
      <soft-comment ref="comment"></soft-comment>
    </div>
    <div style="margin-top: 30px" v-show="current===1">
      <report ref="report" :resume="record" :jobName="record.job_name"></report>
    </div>
    <div style="margin-top: 30px" v-show="current===2">
      <a-result
          status="success"
          title="恭喜您，推荐成功"
      >
        <template #extra>
          <a-button key="console" type="primary" @click="visible=false">
            关闭
          </a-button>
        </template>
      </a-result>
    </div>
    <a-divider v-if="current!=2"></a-divider>
    <a-row type="flex" :gutter="10" justify="end" v-if="current!=2">
      <a-col v-if="end_show">
        <a-button @click="handleCancel"
        >{{ end_text }}
        </a-button
        >
      </a-col>
      <a-col>
        <a-button type="primary" @click="handleOk" :loading="sureLoading"
        >{{ end_ok }}
        </a-button
        >
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import SoftComment from "@/components/soft-comment";
import Report from "@/components/recomend/report"
import Api from "@/api";

export default {
  name: "CheckInterviewModal",
  data() {
    return {
      current: 0,
      steps: [
        {
          title: '软性点评',
          content: 'First-content',
        },
        {
          title: '推荐报告',
          content: 'Second-content',
        },
        {
          title: '完成',
          content: 'Last-content',
        },
      ],
      visible: false,
      sureLoading: false,
      record: undefined,
      interview: undefined,
      end_show: true,
      end_ok:'下一步',
      end_text: "取消"
    };
  },
  components: {SoftComment, Report},
  computed: {},
  created() {
  },
  methods: {
    show(record) {
      this.record = {...record};
      this.interview = record.interviews[0];
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    //通过面试
    async handleOk() {
      this.sureLoading = true;
      try {
        console.log(this.current)
        if (this.current === 1) {
          this.$refs.report.submit().then(async res => {
            let data = {
              ...res,
              resume_id: this.record.resume_id,
              job_id: this.record.job_id,
              post_id:this.record.id
            }
            try {
              await Api.resume.reportUpdate(data);
              this.current++;
              this.end_ok = '完成'
              this.end_show = false;
            } catch (e) {
            }
            console.log(res)
          })
        } else {
          let tags = this.$refs.comment.getCommentFormData();
          console.log(tags)
          if (tags) {
            try {
              await Api.resume.createSoftSkill({
                resume_id: this.record.resume_id,
                tags
              });
              this.current++;
              this.end_text = "上一步"
            } catch (e) {
            }
          }
        }
        // await this.softSkill();
        // await Api.order.interviewConfirm({ post_id: this.record.id });
        // this.close();
        // this.$emit("ok", this.record);
      } catch (e) {
      }
      this.sureLoading = false;
    },
    //通过未面试
    async handleCancel() {
      this.current--;
      if (this.current >= 0) {
        this.end_text = "取消"
      } else {
        this.current = 0;
        this.close();
      }
    },
    softSkill() {
      return new Promise(async (resolve, reject) => {
        let tags = this.$refs.comment.getCommentFormData();
        if (tags) {
          try {
            await Api.resume.createSoftSkill({
              resume_id: this.record.resume_id,
              tags
            });
            resolve();
          } catch (e) {
            reject();
          }
        } else {
          reject();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.card {
  width: 100%;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin: 0 auto;

  .time {
    padding: 25px;
  }
}
</style>
